import { BehaviorSubject } from "rxjs";

if (!global.dataPool) {
    global.dataPool = new BehaviorSubject({});
}

if (!global.behaviorSubjects) {
    global.behaviorSubjects = {
        "customer-search": new BehaviorSubject({}),
    };
}

const DataPool = global.dataPool;
const Subjects = global.behaviorSubjects;

const observables = {
    accountContext: new BehaviorSubject({}),
    accountListing: new BehaviorSubject({}),
    profile: new BehaviorSubject({}),
    budget: new BehaviorSubject({}),
    accountOverview: new BehaviorSubject({}),
    history: new BehaviorSubject({}),
    billHistogram: new BehaviorSubject({}),
    currentUsage: new BehaviorSubject({}),
    balance: new BehaviorSubject({}),
    autopay: new BehaviorSubject({}),
    labels: new BehaviorSubject({}),
    language: new BehaviorSubject({}),
    paymentMethods: new BehaviorSubject({}),
    renderGrid: new BehaviorSubject(true),
    premiseContext: new BehaviorSubject({}),
    premiseListing: new BehaviorSubject({}),
};

export { observables, DataPool, Subjects };
